const baseStyle = {
  borderRadius: '0.69vw',
  px: ['1.5vw', null, null, '1.1vw'],
  h: ['6vw', null, null, '3vw'],
  lineHeight: ['6vw', null, null, '3vw'],
  fontSize: ['4vw', null, null, '2.08vw'],
};

const variantAstro = () => ({
  bg: 'white',
  color: 'black',
});

const variants = {
  astro: variantAstro,
};

const defaultProps = {
  variant: 'astro',
  colorScheme: 'gray',
};

export default {
  baseStyle,
  defaultProps,
  variants,
};
